import React from "react";
import BiddersListAndChatRootCmp from "./ClerkBiddersListAndChatRootCmp";
import ClerkMediaStreamingCmp from "./ClerkMediaStreamingCmp";
import ClerkAuctionInfoHeaderCmp from "./ClerkAuctionInfoHeaderCmp";
import ClerkBiddingAreaLayoutRootCmp from "./bidding/ClerkBiddingAreaLayoutRootCmp";
import ClerkLotsListCmp from "./ClerkLotsListCmp";
import ClerkCurrentRoundCmp from "./ClerkCurrentRoundCmp";
import NetworkAwareBusyOverlayCmp from "../NetworkAwareBusyOverlayCmp";
import ClerkBiddingHistoryCmp from "./bidding/ClerkBiddingHistoryCmp";
import NetworkDisconnectedAlertPanelOverlayCmp from "../NetworkDisconnectedAlertPanelOverlayCmp";
import WebcastPageFooterLineCmp from "../WebcastPageFooterLineCmp";
import ClerkCurrentRoundPrebidsCmp from "./ClerkCurrentRoundHighestOnlineBidsCmp";
import ClerkClosedRoundsCmp from "./ClerkClosedRoundsCmp";
import {TaggedLogger} from "@nextlot/core/utilities";
import {WebcastStateEnum} from "@nextlot/core/webcast/data/WebcastDataDomain";
import useWebcastConnect from "@nextlot/core/webcast/hooks/useWebcastConnect";
import {ChannelEnum} from "@nextlot/core/webcast/redux/actions";



const LOTS_CONTAINER_TAB_LOTS = 'lots';
const LOTS_CONTAINER_TAB_CLOSED_ROUNDS = 'closed_rounds';



const _logger = TaggedLogger.get('ClerkRootCmp');

export default function ClerkRootCmp() {
    // _logger.debug('.render()');

    const webcastStatusState = useWebcastConnect();

    return (
        <>
            <NetworkDisconnectedAlertPanelOverlayCmp />

            {

                (webcastStatusState === WebcastStateEnum.WEBCAST_STATE__CLOSED)
                    ? <FinishedAppStateViewCmp />
                    : (webcastStatusState > WebcastStateEnum.WEBCAST_STATE__LOADING)
                        ? <LoadedAppStateViewCmp webcastStatusState={webcastStatusState} />
                        : <LoadingAppStateViewCmp />

            }

            <WebcastPageFooterLineCmp screenName={'Clerk'} />

        </>
    )
}



function LoadingAppStateViewCmp() {
    return (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            <h3>Loading, please wait ...</h3>
        </div>
    )
}

function FinishedAppStateViewCmp() {
    return (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            <h3>The webcast event has closed. Thank you.</h3>
        </div>
    )
}


function LoadedAppStateViewCmp({ webcastStatusState }:{ webcastStatusState:number }) {

    const [lotsListContainerSelectedTab, setLotsListContainerSelectedTab] = React.useState<string>(LOTS_CONTAINER_TAB_LOTS);

    const handleLotsListContainerTabClick = (tab) => (evt) => {
        evt.preventDefault();
        setLotsListContainerSelectedTab(tab);
    };


    return (
        <div className="webcast-clerk__app-content-container">

            <div className="webcast-clerk__left-vgroup">
                <ClerkMediaStreamingCmp />

                <BiddersListAndChatRootCmp />
            </div>


            <div className="webcast-clerk__middle-right-vgroup">

                <ClerkAuctionInfoHeaderCmp />


                <div className="webcast-clerk__middle-right-columns-hgroup">

                    {
                        (webcastStatusState === WebcastStateEnum.WEBCAST_STATE__LOBBY)

                            ? <ClerkLotsListCmp />

                            : <>

                                <div className="webcast-clerk__middle-column">

                                    <div className="pb-3 position-relative d-flex flex-column">
                                        <NetworkAwareBusyOverlayCmp wbsCommChannel={ChannelEnum.bidding} />

                                        <ClerkBiddingAreaLayoutRootCmp />
                                    </div>



                                    <div className="clerk-lots-and-rounds-tabs-container">
                                        <ul className="nav nav-tabs nav-tabs--webcast-clerk">
                                            <li className="nav-item">
                                                <a className={`nav-link ${lotsListContainerSelectedTab === LOTS_CONTAINER_TAB_LOTS ? 'active' : ''}`} href="#"
                                                   onClick={handleLotsListContainerTabClick(LOTS_CONTAINER_TAB_LOTS)}>Lots</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`nav-link ${lotsListContainerSelectedTab === LOTS_CONTAINER_TAB_CLOSED_ROUNDS ? 'active' : ''}`} href="#"
                                                   onClick={handleLotsListContainerTabClick(LOTS_CONTAINER_TAB_CLOSED_ROUNDS)}>Closed Rounds</a>
                                            </li>
                                        </ul>

                                        {
                                            (lotsListContainerSelectedTab === LOTS_CONTAINER_TAB_LOTS)
                                                ? <ClerkLotsListCmp />
                                                : <ClerkClosedRoundsCmp />
                                        }
                                    </div>

                                </div>



                                <div className="webcast-clerk__right-column">
                                    <ClerkBiddingHistoryCmp />
                                    <ClerkCurrentRoundPrebidsCmp />
                                    <ClerkCurrentRoundCmp />
                                </div>

                            </>
                    }


                </div>
            </div>
        </div>
    )
}
